import React from "react";
import PropTypes from "prop-types";

import Link from "shared/components/Link";
import Overlay from "shared/components/FullscreenOverlay";
import _str from "shared/util/_str";
import isSpa from "shared/util/isSpa";
import useGatekeeper from "shared/hooks/useGatekeeper";
import useModal, { MODALS } from "shared/hooks/useModal";

import { selectedOptionOnNavBarEvent } from "routers/Desktop/NavBar/components/util/analytics";
import { getGlobalPreferencesUrl } from "shared/util/globalPreferences";
import { VIEWDED_GP_SOURCES } from "analytics/globalPreferences";

import "./ProfileMenu.scss";

const ProfileMenu = ({ isFlagMod, onClose }) => {
	const [needsDetailsReboarding] = useGatekeeper("NEEDS_DETAILS_REBOARDING");
	const { open: openGlobalPreferences } = useModal(MODALS.globalPreferences);

	const PROFILE_MENU_LINKS = [
		{
			displayText: _str("Profile"),
			path: "/profile",
			noSpa: !isSpa(),
			extra: needsDetailsReboarding && <div className="profile-menu-notification">!</div>,
		},
		{
			displayText: _str("My Ideal Person"),
			path: getGlobalPreferencesUrl(VIEWDED_GP_SOURCES.PROFILE_MENU),
			noSpa: !isSpa(),
			onClick: () => {
				openGlobalPreferences();
			},
		},
		{
			displayText: _str("Settings"),
			path: "/settings",
			noSpa: !isSpa(),
		},
		{
			displayText: _str("Help"),
			path: "https://help.okcupid.com/",
			target: "_blank",
			noSpa: true,
		},
		{
			displayText: _str("Sign Out"),
			path: "/logout",
			noSpa: !isSpa(),
		},
	];

	if (isFlagMod) {
		const FLAG_MOD_LINK = {
			displayText: _str("Review Photos"),
			path: "/flagmod",
			noSpa: true,
		};

		// Place flagmod before sign out.
		const signOutIndex = PROFILE_MENU_LINKS.findIndex(({ path }) => path === "/logout");
		PROFILE_MENU_LINKS.splice(signOutIndex, 0, FLAG_MOD_LINK);
	}

	return (
		<>
			<div className="profile-menu">
				{PROFILE_MENU_LINKS.map((menuLink) => (
					<Link
						key={menuLink.displayText}
						to={menuLink.path}
						className="profile-menu-link"
						onClick={() => {
							menuLink?.onClick?.();
							selectedOptionOnNavBarEvent(menuLink.displayText);
							onClose();
						}}
						target={menuLink.target}
						noSpa={menuLink.noSpa}
					>
						{menuLink.displayText} {menuLink.extra}
					</Link>
				))}
			</div>
			<Overlay onClick={onClose} />
		</>
	);
};

ProfileMenu.defaultProps = {
	isFlagMod: false,
};

ProfileMenu.propTypes = {
	isFlagMod: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
};

export default ProfileMenu;



// WEBPACK FOOTER //
// ./src/routers/Desktop/NavBar/components/ProfileMenu.jsx